import React from 'react';
import Header from '../Controller/Header';
import AddressesView from '../Controller/AddressesView'
function Addresses() {
    return (
        <>
            <Header />
            <AddressesView/>
        </>
    );
}

export default Addresses;
